import React from 'react';
import styled from 'styled-components';
import { Box, Link } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ExternalLink = function ExternalLink(_ref) {
  var title = _ref.title,
      link = _ref.link,
      onLinkClick = _ref.onLinkClick;
  return /*#__PURE__*/_jsxs(Box, {
    $styles: {
      width: [325, 550, 550, 550]
    },
    $mb: [52, 80, 80, 80],
    children: [/*#__PURE__*/_jsx(TopStroke, {}), /*#__PURE__*/_jsx(BlogLink, {
      $mt: [24, 40, 40, 40],
      href: link,
      onClick: function onClick(e) {
        if (onLinkClick) {
          e.preventDefault();
          onLinkClick(e);
        }
      },
      children: title
    })]
  });
};

var BlogLink = styled(Link).withConfig({
  displayName: "ExternalLink__BlogLink",
  componentId: "sc-6lw4fh-0"
})(["font-weight:400;", " border-bottom:none;transition:color ", ";color:", ";&:hover{color:", ";}"], function (props) {
  return props.theme.normalizeStyles(props.theme.typography.paragraphs.p0);
}, function (props) {
  return props.theme.animation.transitionDuration;
}, function (props) {
  return props.theme.colors.primaryIndigo;
}, function (props) {
  return props.theme.colors.primaryBlue;
});
var TopStroke = styled.div.withConfig({
  displayName: "ExternalLink__TopStroke",
  componentId: "sc-6lw4fh-1"
})(["height:1px;border-radius:2px;background-color:var(--deprecated-legacy-colors-indigo-90-alpha-20);"]);
export default ExternalLink;